<template>
  <div id="bio-input">
    <div class="jacket" :style="{ border: borderObj }">
      <div class="input-jacket">
        <input
          :type="type"
          :placeholder="placeholder"
          @focus="onFocus()"
          @blur="onBlur()"
          v-bind:value="value"
          v-on:input="$emit('input', $event.target.value)"
        />
      </div>
      <div class="icon">
        <!-- <i class="fas fa-lg fl" :class="leftIcon"></i> -->
        <!-- <i  :class="leftIcon" style="font-size:26px"></i> -->
        <!-- <i class="iconfont icon-mobile" :class="leftIcon"></i>
        <i class="iconfont icon-lock" :class="leftIcon"></i>-->

        <div v-show="error">
          <i class="fas fa-times-circle fa-lg fr"></i>
        </div>
      </div>
    </div>
    <div class="error-text" v-if="error">{{errorTxt}}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    placeholder: {
      default: ""
    },
    error: {
      default: false
    },
    leftIcon: {
      default: ""
    },
    active: {
      default: false
    },
    errorTxt: {
      default: ""
    },
    type: {
      default: "text"
    }
  },
  data() {
    return {
      //
      focus: false,
      borderObj: "1px solid #ddd"
    };
  },
  methods: {
    onFocus() {
      this.borderObj = "1px solid #666";
    },
    onBlur() {
      this.borderObj = "1px solid #ddd";
    }
  },
  watch: {
    error(v) {
      if (v) {
        this.borderObj = "1px solid #e2211c";
      } else {
        this.borderObj = "1px solid #ddd";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#bio-input {
  .jacket {
    border: 1px solid #dddddd;
    padding: 10px 10px;
    border-radius: 5px;
    transition: all 0.5s;
    input {
      border: 0;
      width: 100%;
      display: block;
    }
    .input-jacket {
      padding: 0 25px;
    }
    .fl {
      float: left;
      color: #ccc;
    }
    .fr {
      float: right;
      color: #e2211c;
    }
    .icon {
      position: relative;
      top: -17px;
    }
  }
  .error-text {
    color: #e2211c;
    line-height: 30px;
    font-size: 12px;
    text-align: left;
  }
}
</style>
